import React from "react";

const EasasGlobalTooltip = () => {
  return (
    <span
      style={{ display: "none", color: "#1d1d1d" }}
      id="simple-tooltip-new"
      className="simple-tooltip"
    />
  );
};

export default EasasGlobalTooltip;
